"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContactsInfoBox;

var _react = _interopRequireDefault(require("react"));

var _AccordionTransition = _interopRequireDefault(require("UIComponents/transitions/AccordionTransition"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var StyledUITile = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "ContactsInfoBox__StyledUITile",
  componentId: "sc-1tadd64-0"
})(["margin-top:24px;font-size:12px;padding:16px;background-color:", ";"], _colors.GYPSUM);

function ContactsInfoBox(_ref) {
  var titleKey = _ref.titleKey,
      content = _ref.content,
      showBox = _ref.showBox;
  return _react.default.createElement(_AccordionTransition.default, {
    open: showBox
  }, _react.default.createElement(StyledUITile, null, _react.default.createElement("div", {
    style: {
      fontWeight: 500
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: titleKey
  })), content));
}

module.exports = exports.default;